const integerNormalization = (value, previousValue) => {
    let number = parseFloat(value);
    if(Number.isInteger(number)){
        return number.toFixed(0);
    }
    return previousValue;
  }
  export default integerNormalization